var _defs, _ellipse, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChangeCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #ff6a0c;\n      }\n\n      .st2 {\n        fill: #fff;\n      }\n\n      .st3 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 9,
    y: 9,
    width: 49,
    height: 49,
    transform: "translate(-12.3 45.8) rotate(-60)"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 33,
    cy: 33,
    rx: 14.8,
    ry: 14.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M15.8,23.3c-5.6,9.8-2.3,22.3,7.5,27.9,9.8,5.6,22.3,2.3,27.9-7.5,5.6-9.8,2.3-22.3-7.5-27.9-9.8-5.6-22.3-2.3-27.9,7.5ZM45.3,38.2c0,.2,0,.4,0,.6,0,.2-.2.4-.3.5-.2.1-.3.2-.5.2-.2,0-.4,0-.6-.1l-1.4-.8h0c-1.3,2.4-3.5,4.1-6.2,4.9-1.9.5-3.9.5-5.8-.1-1.9-.6-3.5-1.7-4.8-3.2-.7-.9-.3-2.2.8-2.4.6-.2,1.2,0,1.6.5,1.7,2.1,4.5,3.1,7.3,2.3,2-.5,3.5-1.8,4.4-3.5l-1.7-1c-.8-.5-.6-1.6.2-1.9l4.5-1.2c.6-.1,1.1.2,1.3.7l1.2,4.5ZM40.6,29.5c-.3,0-.6,0-.9,0-.3,0-.5-.3-.7-.5-1.7-2.1-4.5-3.1-7.3-2.3-2,.5-3.5,1.8-4.4,3.4l1.7,1c.8.5.6,1.6-.2,1.9l-4.5,1.2c-.6.1-1.1-.2-1.3-.7l-1.2-4.5c0-.2,0-.4,0-.6,0-.2.2-.4.3-.5.2-.1.3-.2.5-.2.2,0,.4,0,.6.1l1.4.8c1.3-2.3,3.5-4.2,6.2-4.9,1.9-.5,3.9-.5,5.8.1,1.9.6,3.5,1.7,4.8,3.2.7.9.3,2.2-.8,2.4Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeCircle);
export default __webpack_public_path__ + "static/media/change-circle.79b5b352d7d9975ac39d1a9024fd2e54.svg";
export { ForwardRef as ReactComponent };